import React from 'react';
import './MessagesShared.css';

const ConversationList = ({
    conversations,
    loading,
    emptyText,
    onSelect,
    selectedConversationId,
}) => {
    if (loading && (!conversations || conversations.length === 0)) {
        return null;
    }

    if (!conversations || conversations.length === 0) {
        return (
            <p className="messages-empty">
                {emptyText || 'No conversations yet - message a seller from any listing.'}
            </p>
        );
    }

    return (
        <ul className="conversation-list">
            {conversations.map((conversation) => (
                <li key={conversation.conversationId} className="conversation-row">
                    <button
                        type="button"
                        className={`conversation-item ${selectedConversationId === conversation.conversationId ? 'active' : ''} ${conversation.unreadCount > 0 ? 'is-unread' : ''}`}
                        onClick={() => onSelect(conversation)}
                    >
                        <span className="conversation-avatar" aria-hidden="true">
                            {(conversation.otherUsername || '?').charAt(0).toUpperCase()}
                        </span>
                        <div className="conversation-body">
                            <div className="conversation-main">
                                <strong>{conversation.otherUsername}</strong>
                                {conversation.unreadCount > 0 && (
                                    <span className="unread-badge">{conversation.unreadCount}</span>
                                )}
                            </div>
                            {conversation.itemTitle ? (
                                <p className="conversation-item-context">{conversation.itemTitle}</p>
                            ) : null}
                            <p className="conversation-preview">{conversation.lastMessagePreview || 'No messages yet'}</p>
                        </div>
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default ConversationList;
